import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

const Cell = ({ label, value }) => (
  <div className="sm:text-center">
    <p className="text-[10px] text-muted-foreground">{label}</p>
    <p className="font-mono text-sm font-bold">
      <span className="num inline-block">{value}</span>
    </p>
  </div>
);

// تفاصيل مستند: السطور والمجاميع وتجميع الضريبة.
export const DocDetail = ({ doc }) => {
  const { t } = useTranslation();
  const currency = doc.money?.currency || "AED";

  return (
    <div className="grid gap-3" data-testid="sales-doc-detail">
      <div className="grid gap-2">
        {(doc.lines || []).map((line) => (
          <NeuCard key={line.line_no} className="grid gap-2 p-4 sm:grid-cols-[1.6fr_repeat(4,minmax(0,1fr))] sm:items-center sm:text-center"
                   data-testid={`doc-line-${line.line_no}`}>
            <p className="truncate text-sm font-bold sm:text-start">{line.description}</p>
            <Cell label={t("sales.qty")} value={`${line.quantity} ${line.uom}`} />
            <Cell label={t("sales.unitPrice")} value={line.unit_price} />
            <Cell label={t("sales.tax")} value={`${line.tax_category} ${line.tax_rate}%`} />
            <Cell label={t("sales.lineTotal")} value={line.line_total} />
          </NeuCard>
        ))}
      </div>

      <NeuCard className="grid gap-2 p-4 sm:grid-cols-4" data-testid="doc-totals">
        <Cell label={t("sales.net")} value={`${doc.totals?.lines_net} ${currency}`} />
        <Cell label={t("sales.discounts")} value={doc.totals?.document_discount} />
        <Cell label={t("sales.taxTotal")} value={doc.totals?.tax_total} />
        <Cell label={t("sales.payable")} value={`${doc.totals?.payable} ${currency}`} />
      </NeuCard>

      <NeuCard className="p-4" data-testid="doc-tax-subtotals">
        <p className="label-xs">{t("sales.taxBreakdown")}</p>
        <div className="mt-2 grid gap-2">
          {(doc.tax_subtotals || []).map((row) => (
            <div key={`${row.category_code}${row.rate}`} className="flex items-center justify-between gap-2 rounded-2xl px-3 py-2 shadow-neu-in">
              <span className="text-[11px] font-bold">
                {t(`sales.taxCategory.${row.category_code}`, row.category_code)} · {row.rate}%
              </span>
              <span className="font-mono text-xs num">
                {row.taxable_amount} → {row.tax_amount}
              </span>
            </div>
          ))}
        </div>
      </NeuCard>
    </div>
  );
};
